/* Moved from snippets/cart-drawer.liquid so browsers cache it (speed audit, 15 Oct 2026). */
/* HLTH cart drawer — runtime safety patches + UI behaviour.
   The shipped Dawn cart.js has a few issues that surface here:
     (1) updateQuantity's trailing trapFocus call references `.drawer__inner-empty`
         and `.cart-item__name`. When those aren't found in our custom markup,
         trapFocus(null, ...) -> getFocusableElements(null) throws, the fetch
         .then rejects into .catch, and the user sees the generic error text.
     (2) The error box is never cleared on a successful update, so stale error
         text lingers across valid operations.
   Fix: make trapFocus / getFocusableElements null-safe, and clear errors before
   each updateQuantity call.

   Also: the drawer is updated in place (below); trust ribbon rotation; Subscribe & Save and
   how-often buttons on the lines. */
(function () {
  var SECTIONS_URL = '/?sections=cart-drawer,cart-icon-bubble';

  /* ---- Basket changes under way (the drawer refresh below drops answers they make stale) ---- */
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var changesStarted = 0;
  var changesInFlight = 0;
  var idleWaiters = [];
  (function countChanges() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function' || nativeFetch.__hlthCounted) return;
    var counted = function (input) {
      var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || String(input || '');
      if (!CART_CHANGE.test(url)) return nativeFetch.apply(window, arguments);
      changesStarted++;
      changesInFlight++;
      var settle = function () {
        changesInFlight = Math.max(0, changesInFlight - 1);
        if (changesInFlight) return;
        var waiting = idleWaiters;
        idleWaiters = [];
        waiting.forEach(function (fn) { fn(); });
      };
      var request = nativeFetch.apply(window, arguments);
      request.then(settle, settle);
      return request;
    };
    counted.__hlthCounted = true;
    window.fetch = counted;
  })();
  function whenIdle() {
    return changesInFlight ? new Promise(function (resolve) { idleWaiters.push(resolve); }) : Promise.resolve();
  }

  /* ---- The drawer is updated in place (16 Oct 2026) ----
     Every script that redraws the drawer (Dawn's cart code after a quantity change or remove, the
     product forms on the suggestion cards, the buy box and sticky bar, the free gift, the free
     shaker, the 2-bag notice and the plan buttons below) used to replace its markup wholesale.
     Each replacement blanked the lines (they faded back in one by one), threw the list back to the
     top and dropped the overlay's click-to-close, and one add set off three of them. Now a write to
     the drawer's markup (the innerHTML of <cart-drawer>, #CartDrawer or the panel) goes through
     morph(), which compares the fresh markup with what is on screen and changes only what
     differs. Lines and suggestion cards are matched by variant, everything else by tag and class
     in order, so the drawer, its scroll position, images, focus and handlers stay put. While the
     drawer is open, a new line, card or block grows in and a removed one shrinks out. */
  var TRANSIENT_CLASS = { hidden: 1, active: 1, animate: 1, loading: 1, disabled: 1, 'hlth-bump': 1, 'cart__items--disabled': 1 };
  var ANIMATED = '.hlth-cart__item, .hlth-cart__items, .hlth-cart__empty, .hlth-cart__routine, .hlth-cart__routine-card, ' +
    '.hlth-shaker-banner, .hlth-shaker-banner__note, .hlth-cart__submin, .hlth-cart__totals-row, ' +
    '.hlth-cart__cart-discounts, .hlth-cart__item-frequency';
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var innerHTMLDesc = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML') ||
    Object.getOwnPropertyDescriptor(HTMLElement.prototype, 'innerHTML');

  function structuralClass(c) {
    return c && !TRANSIENT_CLASS[c] && !/^(is|has)-/.test(c);
  }

  // What an element is, for matching without a key: its tag and lasting classes (a form field: its name).
  function identity(n) {
    if (n.nodeType !== 1) return '#' + n.nodeType;
    var tag = n.tagName;
    if (tag.indexOf('-') > 0) return tag;
    var name = n.getAttribute('name');
    if (name && /^(BUTTON|INPUT|TEXTAREA|SELECT)$/.test(tag)) return tag + '[' + name + ']';
    return tag + '.' + (n.getAttribute('class') || '').split(/\s+/).filter(structuralClass).sort().join('.');
  }

  // Lines and suggestion cards carry a key: their variant (and which one of that variant, in order).
  function baseKey(n) {
    if (n.nodeType !== 1 || !n.classList) return null;
    if (n.classList.contains('hlth-cart__item')) {
      var q = n.querySelector('[data-quantity-variant-id]');
      return 'line:' + (q ? q.getAttribute('data-quantity-variant-id') : '');
    }
    if (n.classList.contains('hlth-cart__routine-card')) {
      var v = n.querySelector('input[name="id"]');
      return 'card:' + (v ? v.getAttribute('value') : '');
    }
    return null;
  }

  function keysOf(nodes) {
    var count = {};
    return nodes.map(function (n) {
      var k = baseKey(n);
      if (k === null) return null;
      count[k] = (count[k] || 0) + 1;
      return k + '#' + count[k];
    });
  }

  function morphChildren(from, to, ctx) {
    var live = [];
    for (var c = from.firstChild; c; c = c.nextSibling) {
      if (!c.__hlthLeaving) live.push(c);
    }
    var want = Array.prototype.slice.call(to.childNodes);
    var liveKeys = keysOf(live);
    var wantKeys = keysOf(want);
    var matchOf = [];
    var taken = new Set();
    var byKey = {};
    live.forEach(function (n, i) {
      if (liveKeys[i] !== null) byKey[liveKeys[i]] = n;
    });
    want.forEach(function (w, j) {
      var k = wantKeys[j];
      if (k === null) return;
      var n = byKey[k];
      if (n && !taken.has(n) && identity(n) === identity(w)) {
        matchOf[j] = n;
        taken.add(n);
      }
    });
    // The rest in order. Text only pairs with the next free node; an element may skip ahead.
    var scanFrom = 0;
    want.forEach(function (w, j) {
      if (wantKeys[j] !== null) return;
      var id = identity(w);
      for (var i = scanFrom; i < live.length; i++) {
        var n = live[i];
        if (taken.has(n) || liveKeys[i] !== null) continue;
        if (identity(n) === id) {
          matchOf[j] = n;
          taken.add(n);
          scanFrom = i + 1;
          break;
        }
        if (w.nodeType !== 1) break;
      }
    });

    var cursor = from.firstChild;
    want.forEach(function (w, j) {
      while (cursor && (cursor.__hlthLeaving || !taken.has(cursor))) cursor = cursor.nextSibling;
      var m = matchOf[j];
      if (m) {
        if (m === cursor) cursor = cursor.nextSibling;
        else from.insertBefore(m, cursor);
        morphNode(m, w, ctx);
      } else {
        var node = document.importNode(w, true);
        from.insertBefore(node, cursor);
        if (node.nodeType === 1) ctx.entered.push(node);
      }
    });
    live.forEach(function (n) {
      if (!taken.has(n)) ctx.leaving.push(n);
    });
  }

  function morphNode(a, b, ctx) {
    if (a.nodeType !== 1) {
      if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue;
      return;
    }
    if (a.hasAttribute('data-ribbon')) return; // the trust ribbon rotates on its own
    morphAttrs(a, b);
    if (a.tagName === 'TEXTAREA') {
      var text = b.textContent;
      if (a.defaultValue !== text) a.defaultValue = text;
      if (document.activeElement !== a && a.value !== text) a.value = text;
      return;
    }
    morphChildren(a, b, ctx);
  }

  // Never touched: the note's open state, a summary's expanded state, image loading (eager once shown).
  function untouched(tag, name) {
    return (tag === 'DETAILS' && name === 'open') || (tag === 'SUMMARY' && name === 'aria-expanded') ||
      (tag === 'IMG' && name === 'loading');
  }
  // Added by scripts, not in the markup: kept.
  function keptIfMissing(tag, name) {
    return name === 'aria-haspopup' || (tag === 'SUMMARY' && (name === 'role' || name === 'aria-controls'));
  }

  function morphAttrs(a, b) {
    var tag = a.tagName;
    var i;
    var name;
    for (i = 0; i < b.attributes.length; i++) {
      name = b.attributes[i].name;
      if (untouched(tag, name)) continue;
      if (a.getAttribute(name) !== b.attributes[i].value) a.setAttribute(name, b.attributes[i].value);
    }
    for (i = a.attributes.length - 1; i >= 0; i--) {
      name = a.attributes[i].name;
      if (untouched(tag, name) || keptIfMissing(tag, name)) continue;
      if (!b.hasAttribute(name)) a.removeAttribute(name);
    }
    if (tag === 'INPUT' && a.type !== 'hidden' && a.type !== 'checkbox' && a.type !== 'radio') {
      var v = b.getAttribute('value');
      if (v !== null && a.value !== v) {
        // After the caller's own reads in this task (Dawn compares the quantity asked for with the
        // basket's to word its "only N available" message), the box shows the basket's number.
        queueMicrotask(function () {
          if (a.value !== v) a.value = v;
        });
      }
    }
  }

  function canAnimate() {
    var cd = document.querySelector('cart-drawer');
    return !!(cd && cd.classList.contains('active') && document.visibilityState === 'visible' &&
      !(reduceMotion && reduceMotion.matches) && typeof Element.prototype.animate === 'function');
  }

  function whenImagesReady(el, ms) {
    var imgs = Array.prototype.filter.call(el.querySelectorAll('img'), function (img) { return !img.complete; });
    if (!imgs.length) return Promise.resolve();
    return new Promise(function (resolve) {
      var left = imgs.length;
      var timer = setTimeout(resolve, ms);
      imgs.forEach(function (img) {
        var one = function () {
          left -= 1;
          if (left <= 0) {
            clearTimeout(timer);
            resolve();
          }
        };
        img.addEventListener('load', one, { once: true });
        img.addEventListener('error', one, { once: true });
      });
    });
  }

  function eagerImages(el) {
    if (el.tagName === 'IMG' && el.loading === 'lazy') el.loading = 'eager';
    el.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }

  // A new line, card or block opens to its height; its content fades in once its image is ready.
  function growIn(el) {
    var h = el.getBoundingClientRect().height;
    if (!h) return;
    var cs = getComputedStyle(el);
    el.style.overflow = 'hidden';
    el.style.opacity = '0';
    var grow = el.animate([
      { height: '0px', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px' },
      { height: h + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, marginTop: cs.marginTop, marginBottom: cs.marginBottom }
    ], { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
    var settle = function () { el.style.overflow = ''; };
    grow.onfinish = settle;
    grow.oncancel = settle;
    whenImagesReady(el, 320).then(function () {
      el.style.opacity = '';
      if (el.isConnected) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' });
    });
  }

  // A removed line, card or block closes up while it fades, then goes. Out of the page's way
  // meanwhile: no ids (Dawn finds lines by index id), no form fields, no clicks.
  function shrinkOut(el) {
    el.__hlthLeaving = true;
    var h = el.getBoundingClientRect().height;
    el.removeAttribute('id');
    el.querySelectorAll('[id]').forEach(function (x) { x.removeAttribute('id'); });
    el.querySelectorAll('input, button, select, textarea').forEach(function (x) { x.disabled = true; });
    el.setAttribute('inert', '');
    el.setAttribute('aria-hidden', 'true');
    if (!h) {
      el.remove();
      return;
    }
    var cs = getComputedStyle(el);
    el.getAnimations().forEach(function (a) { a.cancel(); });
    el.style.overflow = 'hidden';
    el.style.pointerEvents = 'none';
    var shrink = el.animate([
      { height: h + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, marginTop: cs.marginTop,
        marginBottom: cs.marginBottom, borderTopWidth: cs.borderTopWidth, opacity: 1 },
      { height: '0px', paddingTop: '0px', paddingBottom: '0px', marginTop: '0px', marginBottom: '0px',
        borderTopWidth: '0px', opacity: 0 }
    ], { duration: 240, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' });
    var gone = false;
    var done = function () {
      if (gone) return;
      gone = true;
      el.remove();
    };
    shrink.onfinish = done;
    shrink.oncancel = done;
    setTimeout(done, 700);
  }

  function syncEmpty() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    var empty = !!cd.querySelector('.hlth-cart__empty:not([inert])');
    cd.classList.toggle('is-empty', empty);
    var items = cd.querySelector('cart-drawer-items');
    if (items) items.classList.toggle('is-empty', empty);
  }

  function morph(el, source) {
    var ctx = { animate: canAnimate(), entered: [], leaving: [] };
    morphChildren(el, source, ctx);
    ctx.leaving.forEach(function (n) {
      if (ctx.animate && n.nodeType === 1 && n.matches(ANIMATED)) shrinkOut(n);
      else if (n.parentNode) n.parentNode.removeChild(n);
    });
    ctx.entered.forEach(function (n) {
      eagerImages(n);
      if (ctx.animate && n.matches(ANIMATED)) growIn(n);
    });
    syncEmpty();
    bindRibbon();
    // Steppers grey out their minus at the minimum: recheck once the boxes show the basket's numbers.
    queueMicrotask(function () {
      document.querySelectorAll('cart-drawer quantity-input').forEach(function (q) {
        if (typeof q.validateQtyRules === 'function') {
          try { q.validateQtyRules(); } catch (_) { /* noop */ }
        }
      });
    });
  }

  // Writes to these elements' innerHTML are morphed rather than replaced.
  function morphOnWrite(el) {
    if (!el || el.__hlthMorphs || !innerHTMLDesc) return;
    el.__hlthMorphs = true;
    Object.defineProperty(el, 'innerHTML', {
      configurable: true,
      get: function () { return innerHTMLDesc.get.call(this); },
      set: function (html) {
        var tpl = document.createElement('template');
        innerHTMLDesc.set.call(tpl, html);
        morph(this, tpl.content);
      }
    });
  }

  function watchDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    morphOnWrite(cd);
    morphOnWrite(document.getElementById('CartDrawer'));
    morphOnWrite(cd.querySelector('.drawer__inner'));
  }

  // Draw the drawer and the cart count from a sections answer, in place and without opening it.
  function renderSections(sections) {
    if (!sections) return;
    var live = document.getElementById('CartDrawer');
    if (sections['cart-drawer'] && live) {
      var fresh = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').getElementById('CartDrawer');
      if (fresh) morph(live, fresh);
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (sections['cart-icon-bubble'] && bubble) {
      var src = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (src && bubble.innerHTML !== src.innerHTML) bubble.innerHTML = src.innerHTML;
    }
  }

  function refreshCartSections() {
    return fetch(SECTIONS_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderSections)
      .catch(function (_) {});
  }

  // Fetch the drawer again after a basket change that didn't draw it. Calls close together share
  // one fetch; it waits for changes under way and is dropped (and redone) if another starts meanwhile.
  var refreshTimer = null;
  var refreshWaiters = [];
  function scheduleRefresh() {
    return new Promise(function (resolve) {
      refreshWaiters.push(resolve);
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(runRefresh, 120);
    });
  }
  function runRefresh() {
    var waiters = refreshWaiters;
    refreshWaiters = [];
    whenIdle()
      .then(function () {
        var startedAt = changesStarted;
        return fetch(SECTIONS_URL, { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (changesStarted !== startedAt) return scheduleRefresh();
            renderSections(data);
          });
      })
      .catch(function (_) {})
      .then(function () {
        waiters.forEach(function (fn) { fn(); });
      });
  }

  function patchFocusHelpers() {
    if (typeof window.getFocusableElements === 'function' && !window.getFocusableElements.__hlthWrapped) {
      var origGetFocusable = window.getFocusableElements;
      window.getFocusableElements = function (container) {
        if (!container) return [];
        try { return origGetFocusable(container); } catch (_) { return []; }
      };
      window.getFocusableElements.__hlthWrapped = true;
    }
    if (typeof window.trapFocus === 'function' && !window.trapFocus.__hlthWrapped) {
      var origTrapFocus = window.trapFocus;
      window.trapFocus = function (container, elementToFocus) {
        if (!container) return;
        try { return origTrapFocus(container, elementToFocus); } catch (_) { /* swallow */ }
      };
      window.trapFocus.__hlthWrapped = true;
    }
  }

  function patchCartItems() {
    var Klass = window.customElements && customElements.get('cart-drawer-items');
    if (!Klass || Klass.__hlthPatched) return;
    Klass.__hlthPatched = true;
    var original = Klass.prototype.updateQuantity;
    Klass.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      var errBox = document.getElementById('CartDrawer-CartErrors');
      if (errBox) errBox.textContent = '';
      var lineErr = document.getElementById('CartDrawer-LineItemError-' + line);
      var lineErrText = lineErr && lineErr.querySelector('.cart-item__error-text');
      if (lineErrText) lineErrText.textContent = '';
      var input = document.getElementById('Drawer-quantity-' + line);
      if (input && input.hasAttribute('data-hlth-group')) {
        return updateGroupedRow(this, line, quantity, input);
      }
      return original.call(this, line, quantity, event, name, variantId);
    };
    // Dawn fetched the drawer again after every basket update and swapped its lines and footer in,
    // even right after an add had drawn it. Now one shared, in-place refresh.
    Klass.prototype.onCartUpdate = function () {
      return scheduleRefresh();
    };
  }

  /* ---- One row per product, flavour and plan ----
     The Liquid draws lines Shopify split for a buy-X-get-Y code as one row, at the first line,
     with the other lines' keys and quantities on its input. A change to that row (stepper,
     typed number or the bin) is spread across those lines in one /cart/update.js call:
     the first line takes the difference, and only below the others' total do they shrink.
     Then the drawer is redrawn (refreshCartSections). */
  function updateGroupedRow(items, line, quantity, input) {
    var others = null;
    try { others = JSON.parse(input.getAttribute('data-hlth-group')); } catch (_) {}
    var key = input.getAttribute('data-hlth-key');
    if (!others || !others.length || !key) return Promise.resolve();
    var target = Math.max(0, parseInt(quantity, 10) || 0);
    var offset = others.reduce(function (sum, o) { return sum + o.qty; }, 0);
    var updates = {};
    if (target >= offset) {
      updates[key] = target - offset;
    } else {
      updates[key] = 0;
      var left = target;
      others.forEach(function (o) {
        var q = Math.min(o.qty, left);
        updates[o.key] = q;
        left -= q;
      });
    }
    if (typeof items.enableLoading === 'function') items.enableLoading(line);
    var url = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        return refreshCartSections().then(function () {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
          }
        });
      })
      .catch(function () {
        var errBox = document.getElementById('CartDrawer-CartErrors');
        if (errBox && window.cartStrings) errBox.textContent = window.cartStrings.error;
      })
      .finally(function () {
        if (typeof items.disableLoading === 'function') items.disableLoading(line);
      });
  }

  function patchCartDrawer() {
    var CD = window.customElements && customElements.get('cart-drawer');
    if (!CD || CD.__hlthPatched) return;
    CD.__hlthPatched = true;

    // Dawn's renderContents replaced the whole drawer and bound another overlay click each time.
    // The product forms, the free gift and the 2-bag notice call it: draw in place, then open.
    CD.prototype.renderContents = function (parsedState) {
      this.productId = parsedState && parsedState.id;
      if (parsedState && parsedState.sections) renderSections(parsedState.sections);
      else scheduleRefresh();
      var self = this;
      setTimeout(function () { self.open(); });
    };

    // Images in the drawer start loading as it slides in, not once it's there.
    var open = CD.prototype.open;
    CD.prototype.open = function (triggeredBy) {
      eagerImages(this);
      return open.call(this, triggeredBy);
    };
  }

  /* ---- Trust ribbon rotation ---- */
  function bindRibbon() {
    var ribbons = document.querySelectorAll('[data-ribbon]');
    ribbons.forEach(function (ribbon) {
      if (ribbon.__hlthBound) return;
      ribbon.__hlthBound = true;

      var msgs = Array.prototype.slice.call(ribbon.querySelectorAll('.hlth-cart__ribbon-msg'));
      if (msgs.length <= 1) return;
      var idx = 0;
      function show(i) {
        msgs.forEach(function (m, j) { m.classList.toggle('is-active', j === i); });
      }
      function next() { idx = (idx + 1) % msgs.length; show(idx); }
      function prev() { idx = (idx - 1 + msgs.length) % msgs.length; show(idx); }

      var prevBtn = ribbon.querySelector('[data-ribbon-prev]');
      var nextBtn = ribbon.querySelector('[data-ribbon-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restartTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restartTimer(); });

      var timer = window.setInterval(next, 4500);
      function restartTimer() {
        window.clearInterval(timer);
        timer = window.setInterval(next, 4500);
      }
    });
  }

  /* ---- Subscribe & Save and how often, per line (16 Oct 2026) ----
     The Liquid gives a one-time line of a product listed in Theme settings > Cart drawer a
     Subscribe button (the product's first plan), and every subscription line a how-often button
     whose list holds the product's plans (and One-time, for those listed products). Choosing one
     moves every line of that product to it through /cart/change.js (selling_plan, null for
     one-time), a line at a time because a buy-X-get-Y code can split one row into several lines,
     then redraws the drawer. Product-wide, so both shake flavours keep one delivery and the
     2-bag subscription minimum can't be split into two 1-bag subscriptions.
     Each change answers with the whole basket, which picks the next line; the last one also
     brings the drawer back (one basket read in all, 16 Oct 2026). */
  function closePlanMenus(except) {
    document.querySelectorAll('[data-plan-toggle][aria-expanded="true"]').forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var menu = document.getElementById(btn.getAttribute('aria-controls'));
      if (menu) {
        menu.hidden = true;
        menu.style.left = '';
      }
      var li = btn.closest('.hlth-cart__item');
      if (li) li.classList.remove('is-plan-open');
    });
  }

  function openPlanMenu(btn) {
    var menu = document.getElementById(btn.getAttribute('aria-controls'));
    if (!menu) return;
    closePlanMenus(btn);
    btn.setAttribute('aria-expanded', 'true');
    menu.hidden = false;
    var li = btn.closest('.hlth-cart__item');
    if (li) li.classList.add('is-plan-open');
    // Keep the list inside the drawer: shift it left when it would run past the panel's edge.
    var panel = btn.closest('.hlth-cart__panel');
    if (panel) {
      var over = menu.getBoundingClientRect().right - (panel.getBoundingClientRect().right - 16);
      if (over > 0) menu.style.left = (-over) + 'px';
    }
    if (typeof menu.scrollIntoView === 'function') menu.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    var current = menu.querySelector('[aria-checked="true"]') || menu.querySelector('[data-plan-move]');
    if (current) current.focus({ preventScroll: true });
  }

  function planOf(line) {
    return line.selling_plan_allocation ? String(line.selling_plan_allocation.selling_plan.id) : '';
  }

  // Every line of the product shows its spinner (and dims) while the move saves.
  function productLines(productId) {
    var lines = [];
    document.querySelectorAll('cart-drawer [data-product-id="' + productId + '"]').forEach(function (b) {
      var li = b.closest('.hlth-cart__item');
      if (li && lines.indexOf(li) < 0) lines.push(li);
    });
    return lines;
  }
  function setLinesBusy(lines, on) {
    lines.forEach(function (li) {
      var spinner = li.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !on);
    });
  }

  // topup (1.9.1, 22 Oct 2026): bags added to the first line in the same change, when subscribing one
  // bag would leave the delivery short of the 2-bag minimum ("Add a bag, Subscribe & Save").
  function movePlan(productId, fromPlan, toPlan, line, topup) {
    var items = document.querySelector('cart-drawer-items');
    if (items && typeof items.enableLoading === 'function') items.enableLoading(line);
    var busy = productLines(productId);
    setLinesBusy(busy, true);
    var errText = document.querySelector('#CartDrawer-LineItemError-' + line + ' .cart-item__error-text');
    if (errText) errText.textContent = '';
    var changeUrl = ((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js';
    var rounds = 0;
    // From a plan: every subscription line of the product not yet on the new plan.
    // From one-time (the Subscribe button): every one-time line of the product.
    function todoOf(cart) {
      return (cart.items || []).filter(function (it) {
        if (String(it.product_id) !== String(productId)) return false;
        var on = planOf(it);
        return fromPlan ? on !== '' && on !== String(toPlan || '') : on === '';
      });
    }
    function step(cart) {
      var todo = todoOf(cart);
      if (!todo.length || rounds++ >= 6) return { cart: cart, sections: null };
      var body = { id: todo[0].key, quantity: todo[0].quantity + (topup || 0), selling_plan: toPlan ? Number(toPlan) : null };
      topup = 0;
      var last = todo.length === 1;
      if (last) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      return fetch(changeUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('plan change ' + r.status);
          return r.json();
        })
        .then(function (res) {
          if (last && res.sections && !todoOf(res).length) return { cart: res, sections: res.sections };
          return step(res);
        });
    }
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(step)
      .then(function (out) {
        var drawn = out.sections ? Promise.resolve(renderSections(out.sections)) : refreshCartSections();
        return drawn.then(function () {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: out.cart });
          }
        });
      })
      .catch(function () {
        var el = document.querySelector('#CartDrawer-LineItemError-' + line + ' .cart-item__error-text');
        if (el && window.cartStrings) el.textContent = window.cartStrings.error;
      })
      .finally(function () {
        setLinesBusy(busy, false);
        var fresh = document.querySelector('cart-drawer-items');
        if (fresh && typeof fresh.disableLoading === 'function') fresh.disableLoading(line);
      });
  }

  function bindPlans() {
    if (document.__hlthPlansBound) return;
    document.__hlthPlansBound = true;
    var planMoving = false;
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-plan-toggle]');
      if (toggle) {
        if (toggle.getAttribute('aria-expanded') === 'true') closePlanMenus();
        else openPlanMenu(toggle);
        return;
      }
      var mover = e.target.closest('cart-drawer [data-plan-move]');
      if (mover) {
        var to = mover.getAttribute('data-plan-move');
        var from = mover.getAttribute('data-plan-from');
        closePlanMenus();
        // One move at a time: a second button pressed mid-move would work from a stale basket.
        if (to === from || mover.disabled || planMoving) return;
        mover.disabled = true;
        planMoving = true;
        var topup = parseInt(mover.getAttribute('data-plan-topup'), 10) || 0;
        var productId = mover.getAttribute('data-product-id');
        movePlan(productId, from, to, mover.getAttribute('data-line'), topup)
          .finally(function () {
            mover.disabled = false;
            planMoving = false;
            // Keyboard focus stays in the drawer: the pressed button is gone (Subscribe) or in a closed
            // list after the redraw, so it moves to that product's plan button.
            var active = document.activeElement;
            if (active && active !== document.body && active.closest('cart-drawer') && !active.closest('[hidden]')) return;
            var opt = document.querySelector('cart-drawer [data-plan-move][data-product-id="' + productId + '"]');
            var plan = opt && opt.closest('.hlth-cart__plan');
            var target = plan && (plan.querySelector('[data-plan-toggle]') || opt);
            if (target) target.focus({ preventScroll: true });
          });
        return;
      }
      if (!e.target.closest('.hlth-cart__plan-menu')) closePlanMenus();
    });
    // Arrows move through an open list; Escape closes it without closing the drawer.
    var escClosedMenu = false;
    document.addEventListener('keydown', function (e) {
      var inMenu = document.activeElement && document.activeElement.closest('.hlth-cart__plan-menu');
      if (inMenu && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        var opts = Array.prototype.slice.call(inMenu.querySelectorAll('[data-plan-move]'));
        var at = opts.indexOf(document.activeElement);
        var to = opts[(at + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length];
        if (to) {
          e.preventDefault();
          to.focus();
        }
        return;
      }
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-plan-toggle][aria-expanded="true"]');
      if (!open) return;
      escClosedMenu = true;
      e.stopPropagation();
      closePlanMenus();
      open.focus();
    }, true);
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && escClosedMenu) {
        escClosedMenu = false;
        e.stopPropagation();
      }
    }, true);
  }

  window.HLTHCartDrawer = { render: renderSections, refresh: scheduleRefresh };

  // The drawer's markup is on the page before this runs (deferred), so writes are morphed from now.
  watchDrawer();

  function boot() {
    if (!window.customElements) return;
    customElements.whenDefined('cart-drawer-items').then(function () {
      patchFocusHelpers();
      patchCartItems();
      patchCartDrawer();
      watchDrawer();
      bindRibbon();
      bindPlans();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
